import React from 'react';

import LocalizedLink from 'components/LocalizedLink';
import LegalPageLayout from 'components/LegalPageLayout';
import { useI18n } from 'i18n/I18nContext';

const ContactPage = () => {
  const { t } = useI18n();

  return (
    <LegalPageLayout title={t('contact.title')} lede={t('contact.intro')} variant="marketing">
      <h2 className="text-lg font-bold mb-15">{t('contact.customers')}</h2>
      <p className="mb-25">{t('contact.customersBody')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('contact.legal')}</h2>
      <p className="mb-25">
        {t('contact.legalBefore')}{' '}
        <LocalizedLink className="text-green font-bold no-underline" to="/privacy">
          {t('footer.privacy')}
        </LocalizedLink>{' '}
        {t('contact.legalMid')}{' '}
        <LocalizedLink className="text-green font-bold no-underline" to="/terms">
          {t('footer.terms')}
        </LocalizedLink>
        {t('contact.legalAfter')}
      </p>
    </LegalPageLayout>
  );
};

export default ContactPage;



// WEBPACK FOOTER //
// ./src/pages/ContactPage.tsx